import { SVGProps } from 'react';

export const RightArrowIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={12}
    viewBox="0 0 14 12"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M.75 6a.75.75 0 0 1 .75-.75h9.188L7.468 2.03a.751.751 0 0 1 1.062-1.062l4.5 4.5a.75.75 0 0 1 0 1.063l-4.5 4.5a.751.751 0 0 1-1.062-1.063l3.22-3.22H1.5A.75.75 0 0 1 .75 6Z"
    />
  </svg>
);
